import { Box } from '@leagueplatform/genesis-core';
import {
  CareDiscoveryRoutes,
  WalletRoutes,
  CareDocumentsRoutes,
  HealthJourneyRoutes,
} from 'components/lazy-routes.component';

// CareDiscovery overflows our grid layout parent at the bottom in mobile width.
// It's made of StackLayout, which has height: 100%.
// It's built in Masonry 1.0, so we can't override Masonry's StackLayout (we could in 1.5).
// It doesn't have any distinct class names to target the div directly.
// The grandchildren of this Box are the 2 container columns.
// Adding more elements inside the columns will NOT disrupt the grandchildren selector.

export const StyledCareDiscoveryRoutes = () => (
  <Box
    css={{
      // equal width carousel items
      'ul > li:has(> .GDS-stack-item)': {
        flexGrow: 1,
        flexBasis: 0,
      },
    }}
  >
    <CareDiscoveryRoutes />
  </Box>
);

export const StyledWalletRoutes = () => {
  const WALLET_PAGE_HEADER_HEIGHT = `167px`;

  return (
    <Box
      css={{
        '.cc-page-header-background': {
          height: WALLET_PAGE_HEADER_HEIGHT,
          '&:before': {
            top: `calc(${WALLET_PAGE_HEADER_HEIGHT} - 20024px)`,
          },
        },
      }}
    >
      <WalletRoutes />
    </Box>
  );
};

export const StyledCareDocumentsRoutes = () => (
  <Box
    css={{
      '.document-error-state--noFilteredResults .document-error-state_message':
        {
          maxWidth: 'unset',
        },
    }}
  >
    <CareDocumentsRoutes />
  </Box>
);

export const StyledHealthJourneyRoutes = () => (
  <Box
    css={{
      '.health-activity-page form h2': {
        textAlign: 'center',
      },
      '.health-activity-page form .GDS-box:not(.toolbox-richtext), .health-activity-page form .GDS-form-field':
        {
          marginTop: '$one',
        },
    }}
  >
    <HealthJourneyRoutes />
  </Box>
);
